// import $ from 'jquery';
import Module from '../lib/module';
import Util, { ViewPort } from '../lib/util';
import 'jquery-typeahead';

@Module.define('inputs')
class Inputs extends Module {
	constructor(options) {
		super(options);

		this.InputClasses = {};

		this.formControl = $('body .form-control');

		this.InputClasses.Focus = 'is-focused';
		this.InputClasses.Disabled = 'is-disabled';
		this.InputClasses.Dirty = 'is-dirty';
	}

	main() {
		const _this = this
		this.formControl.each(function(index) {
			_this.UpdateClasses($(this)[0]);
		});	
	}

	bindEvents() {
		this.formControl.on('blur', e => this.InputOnBlur(e));
		this.formControl.on('focus', e => this.InputOnFocus(e));
		this.formControl.on('change', e => this.OnChange(e));
	}

	/**
	 * Handle focus.
	 *
	 * @param {Event} event The event that fired.
	 */
	InputOnFocus(e) {
		let input = $(e.currentTarget);
		input.addClass(this.InputClasses.Focus);

		this.UpdateClasses(input[0]); 

		
	}

	/**
	 * Handle lost focus.
	 *
	 * @param {Event} event The event that fired.
	 */
	InputOnBlur(e) {
		let input = $(e.currentTarget);
		input.removeClass(this.InputClasses.Focus);

		
	}

	/**
	 * Handle class updates.
	 *
	 */
	UpdateClasses(input) {
		this.CheckDisabled(input);
		this.CheckDirty(input);
		this.CheckFocus(input);

		setTimeout(() => {
			this.CheckDisabled(input);
			this.CheckDirty(input);
			this.CheckFocus(input);
		}, 300);	
	}

	OnChange(e) {
		let input = $(e.currentTarget);

		//input.value = value || '';

		this.UpdateClasses(input[0]);
	}

	/**
   * Check the disabled state and update field accordingly.
   *
   */
	CheckDisabled (input) {
		if (input.disabled) {
			$(input).addClass(this.InputClasses.Disabled);
		} 
		else {
			$(input).removeClass(this.InputClasses.Disabled);
		}
	}

	/**
	* Check the focus state and update field accordingly.
	*/
	CheckFocus(input) {
		if ($(input).is(":focus")) {
			$(input).addClass(this.InputClasses.Focus);
		} 
		else {
			$(input).removeClass(this.InputClasses.Focus);
		}
	}

	/**
	* Check the dirty state and update field accordingly.
	*/
	CheckDirty(input) {
		if (input.value && input.value.length > 0) {
			$(input).addClass(this.InputClasses.Dirty);
		} 
		else {
			$(input).removeClass(this.InputClasses.Dirty);
		}
	}
}
